import loadable from '@loadable/component';
import { Routes, Route } from 'react-router-dom';
import _ from 'lodash';

import MainLayout from './pages/layouts/MainLayout';
import { Loader } from './components/Loader';
import { config } from './i18n';

interface PageProps {
  path: string;
}

const Page = loadable<PageProps>(
  async props => import(`./pages/${props.path}`),
  {
    cacheKey: props => props.path,
    fallback: <Loader />,
  },
) as any;

export const routers = [
  { path: '', element: 'Home' },
  { path: 'faq', element: 'views/Faq' },
  { path: 'blog', element: 'views/Blog' },
  { path: 'reviews/vk', element: 'views/Reviews' },
  { path: 'reviews/trustpilot', element: 'views/Reviews' },
  { path: 'reviews/video', element: 'views/Reviews' },
  { path: 'blog/post/:id', element: 'views/Post' },
  { path: 'blog/tag/:tag', element: 'views/Blog' },
  { path: 'blog/search/:search', element: 'views/Blog' },
  { path: 'agreement', element: 'views/Agreement' },
  { path: 'user/:id', element: 'views/User' },
  { path: 'search/:id', element: 'views/Search' },
  { path: 'case/:url', element: 'views/Play' },
  { path: 'case/:url/odds', element: 'views/Odds' },
  { path: 'event/:url', element: 'views/Event' },
  { path: 'battle_pass/:url', element: 'views/BattlePass' },
  { path: 'profile', element: 'views/Profile' },
  { path: 'settings', element: 'views/Settings' },
  { path: 'contract', element: 'views/Contract' },
  { path: 'upgrade', element: 'views/Upgrade' },
  { path: 'wheel', element: 'views/Wheel' },
  { path: 'refunds', element: 'views/Refunds' },
  { path: 'contacts', element: 'views/Contacts' },
  { path: 'privacy_policy', element: 'views/PrivacyPolicy' },
  { path: 'pay', element: 'views/Pay' },
  //  { path: 'provablyFair', element: 'views/ProvablyFair' },
];

const RenderRoutes = () => {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        {_.map(['', ...config.fallbackLng], lang => {
          return _.map(routers, route => (
            <Route
              key={`/${lang}${route.path}`}
              path={`/${lang}${route.path}`}
              element={<Page path={route.element} />}
            />
          ));
        })}
        <Route path="*" element={<Page path="error/NotFound" />} />
      </Route>
    </Routes>
  );
};

export default RenderRoutes;
